// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"476":"veranstaltungen","594":"about","596":"gruppen","665":"kontakt"}[chunkId] + "-legacy." + {"476":"af6c5395","594":"966ce2e6","596":"6ccea5c1","665":"99914749"}[chunkId] + ".js";
};